import styled from "styled-components";

interface IDrawer {
	children: any;
	isOpen: boolean;
	setIsOpen: any;
}
const Wrapper = styled.section`
	top: 86px;
	@media (max-width: 767px) {
		top: 155px;
	}
	@media (max-width: 650px) {
		top: 112px;
	}
`;

export default function Drawer(props: IDrawer) {
	const { children, isOpen, setIsOpen } = props;
	return (
		<div>
			<main
				className={
					" fixed inset-0 z-10 transform overflow-hidden bg-gray-900 bg-opacity-25 ease-in-out " +
					(isOpen
						? " translate-x-0 opacity-100 transition-opacity duration-500 "
						: " translate-x-full opacity-0 transition-all delay-500 ")
				}
			>
				<Wrapper
					className={
						" absolute right-0 h-full w-screen max-w-lg transform bg-white shadow-xl transition-all delay-400 duration-500 ease-in-out " +
						(isOpen ? " translate-x-0 " : " translate-x-full ")
					}
				>
					<article className="relative flex h-full w-screen max-w-lg flex-col space-y-6 overflow-y-scroll pb-10">
						{children}
					</article>
				</Wrapper>
				<section
					className=" h-full w-screen cursor-pointer "
					onClick={() => {
						setIsOpen(false);
					}}
				></section>
			</main>
		</div>
	);
}
